import React from "react";
import { createMarkup, isFieldError } from "../../helpers";

const InputFile = ({ label, note = "", reqd, name, value, update, errors }) => {
  return (
    <div className={isFieldError(errors, name) ? "has-error" : ""}>
      <label htmlFor={name} className="control-label">
        <span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
        {reqd && <span className="reqd">*</span>}
      </label>
      <input
        type="file"
        name={name}
        id={name}
        onChange={(e) => update(e)}
        className={
          isFieldError(errors, name)
            ? "form-control error-border"
            : "form-control"
        }
      />
      <span className={note ? "note" : "hidden"}>{note}</span>
    </div>
  );
};

export default InputFile;
